<template>
  <div v-if="contacts && contacts.length > 0">
    <div v-for="(contact, index) in contacts" :key="index" class="mb-3">
      <div v-if="contacts.length > 1" class="text-xs font-bold text-gray-700 uppercase mb-1">
        Contact #{{ index + 1 }}
      </div>
      <b-row>
        <b-col cols="12" md="6" v-if="contact.email !== undefined">
          <b-form-group
            class="text-sm my-1"
            :id="'input-group-email-' + index"
            label="Email Address"
            :label-for="'input-email-' + index">
            <b-form-input
              class="form-text text-sm noFocus"
              type="text"
              disabled="true"
              :value="contact.email || '–'"
              required>
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" v-if="contact.phone !== undefined">
          <b-form-group
            class="text-sm my-1"
            :id="'input-group-phone-' + index"
            label="Phone Number"
            :label-for="'input-phone-' + index">
            <b-form-input
              class="form-text text-sm noFocus"
              type="text"
              disabled="true"
              :value="contact.phone || '–'"
              required>
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
  <div v-else class="text-center py-4 text-gray-500 text-sm">
    <p>No contact information available</p>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
  props: {
    data: {
      type: [Array, Object, String],
      default: function () { return []; },
    },
  },
  computed: {
    contacts() {
      if (!this.data) return [];
      if (Array.isArray(this.data)) return this.data;
      if (typeof this.data === 'string') return [{ phone: this.data }];
      if (typeof this.data === 'object') return [this.data];
      return [];
    },
  },
};
</script>

<style scoped>

</style>
